// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2322ae49","732":"586528a5","952":"6c643d75","977":"74e5be8c"}[chunkId] + ".chunk.js";
};